import React from 'react';
import { View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { useIconDefinition } from '@/constants/iconRegistry';

// IMPORTANT: NEVER EVER USE colors.accent_color_primary HERE!!!
export default function Icon({
  name,
  size = 16,
  color = 'currentColor',
  style,
  regular,
  light,
  solid,
  ...props
}) {
  const variant = solid ? 'fas' : light ? 'fal' : regular ? 'far' : 'far';
  const icon = useIconDefinition(name, variant);

  // Keep the sized box even with no glyph. Most icons resolve synchronously from the core
  // map, but catalog icons come from a deferred chunk, and returning null outright would
  // collapse the layout and then push it back open when the chunk lands.
  if (!icon) return <View style={[{ width: size, height: size }, style]} />;

  return (
    <View style={[{ width: size, height: size }, style]}>
      <FontAwesomeIcon
        icon={icon}
        size={size}
        color={color}
        style={style}
        {...props}
      />
    </View>
  );
}
